import React, { useEffect, useMemo } from 'react'

import { Layout } from 'antd'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import Navigator from './components/Navigator'
import { getCommonContent } from './redux/actions/common'
import Routes from './Routes'
import './styles/app.css'

const { Content } = Layout

const App = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()

  useMemo(() => {
    i18n.changeLanguage(i18n.language)
  }, [])

  useEffect(() => {
    const lang = i18n.language === 'cn' ? 'en' : i18n.language
    dispatch(getCommonContent(lang))
  }, [i18n.language])

  return (
    <Layout className="layout">
      <Helmet>
        <title>True VROOM SUPPORT</title>
      </Helmet>
      <Router>
        <Navigator />
        <Content className="main">
          <Routes />
        </Content>
      </Router>
      {/* <Footer>Power By</Footer> */}
    </Layout>
  )
}

export default App
